import * as z from "zod/v4";

export const getOkendoIntegration = {
  name: "getOkendoIntegration" as const,
  input: z.object({}),
  output: z.object({
    okendoIntegration: z
      .object({ okendoUserId: z.string(), enabled: z.boolean() })
      .optional(),
  }),
};

export type OkendoIntegrationDto = z.infer<
  typeof getOkendoIntegration.output
>["okendoIntegration"];
